import { DayOfWeekItem } from '@/models/dictionary/day-of-week.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { defineStore } from 'pinia';

interface DayOfWeekState {
  dayOfWeekList: DayOfWeekItem[];
  isDayOfWeekLoading: boolean;
}

export const useDayOfWeekStore = defineStore({
  id: 'dayOfWeekStore',
  state: (): DayOfWeekState => ({
    dayOfWeekList: [],
    isDayOfWeekLoading: false,
  }),
  actions: {
    setDayOfWeekLoading(isLoading: boolean): void {
      this.isDayOfWeekLoading = isLoading;
    },
    getDayOfWeekList(): Promise<DayOfWeekItem[]> {
      if (this.dayOfWeekList.length > 0) {
        return Promise.resolve(this.dayOfWeekList);
      }

      this.setDayOfWeekLoading(true);

      return api.dictionary.getDayOfWeekRequest.perform()
        .then((dayOfWeekList: DayOfWeekItem[]) => {
          this.dayOfWeekList = dayOfWeekList;

          return dayOfWeekList;
        })
        .catch(error => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setDayOfWeekLoading(false);
        });
    },
  },
});
